var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.2 49.4",
    style: {
      enableBackground: "new 0 0 54.2 49.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,20.3c2.9,0,5.4,0,7.8,0c8.5,0,17,0,25.5,0c3.3,0,5.3,1.8,5.3,4.6c0,2.6-2.1,4.4-5.3,4.4 c-10.2,0-20.3,0-30.5,0c-0.8,0-1.5,0-2.9,0c3.2,3.2,6,6,8.8,8.9c1.2,1.3,2.6,2.5,3.7,3.8c1.6,1.8,1.5,4.5-0.2,6.1 c-1.6,1.7-4.3,1.9-6.1,0.2C14.8,41.4,8,34.5,1.2,27.6c-1.7-1.7-1.6-4.1,0.2-5.9C8.1,14.8,14.8,8.1,21.6,1.3c1.9-1.9,4.4-1.7,6.2,0.1 c1.7,1.7,1.8,4.4,0,6.3c-3.4,3.6-7,7.1-10.5,10.7C16.9,18.9,16.4,19.4,15.6,20.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.099cab756703853bd8bd135dfb007aad.svg";
export { ForwardRef as ReactComponent };